import React, { useEffect, useRef } from 'react';

const FLASHLIGHT_SIZE = 400; // px

const FlashlightEffect = ({ aboutRef }) => {
    const flashlightRef = useRef(null);

    useEffect(() => {
        const flashlight = flashlightRef.current;
        let mouseX = 0;
        let mouseY = 0;
        let currentX = 0;
        let currentY = 0;

        const handleMouseMove = (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;

            // Fade based on distance from About section
            let opacity = 1;
            if (aboutRef?.current) {
                const rect = aboutRef.current.getBoundingClientRect();
                const inside =
                    mouseX >= rect.left &&
                    mouseX <= rect.right &&
                    mouseY >= rect.top &&
                    mouseY <= rect.bottom;

                if (!inside) {
                    // Calculate distance to nearest edge
                    const dx = Math.max(rect.left - mouseX, 0, mouseX - rect.right);
                    const dy = Math.max(rect.top - mouseY, 0, mouseY - rect.bottom);
                    const dist = Math.sqrt(dx * dx + dy * dy);
                    opacity = Math.max(0, 1 - dist / 200); // fade out over 200px
                }
            }
            if (flashlight) flashlight.style.opacity = opacity;
        };

        const animate = () => {
            currentX += (mouseX - currentX) * 0.1;
            currentY += (mouseY - currentY) * 0.1;
            if (flashlight) {
                flashlight.style.left = `${currentX}px`;
                flashlight.style.top = `${currentY}px`;
            }
            requestAnimationFrame(animate);
        };

        document.addEventListener('mousemove', handleMouseMove);
        animate();

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
        };
    }, [aboutRef]);

    return (
        <div
            ref={flashlightRef}
            className="flashlight"
            style={{
                position: 'fixed',
                width: `${FLASHLIGHT_SIZE}px`,
                height: `${FLASHLIGHT_SIZE}px`,
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(168,50,80,0.5) 0%, rgba(168,50,80,0.1) 60%, transparent 100%)',
                pointerEvents: 'none',
                zIndex: 1000,
                transform: 'translate(-50%, -50%)',
                opacity: 0,
                transition: 'opacity 0.3s ease',
                mixBlendMode: 'screen'
            }}
        />
    );
};

export default FlashlightEffect;